export default __webpack_public_path__ + "static/media/default_doctor_img.dec98aaf.png";